module.exports = __webpack_public_path__ + "static/media/t1.18340c3f.jpg";